<div class="page-header">
  <div class="container-fluid header-shell px-3 px-md-4">
    <div class="header-content">
      <button type="button" class="logo-wrapper logo-button" (click)="goToLandingPage()" aria-label="Vai alla landing page">
        <img
          [src]="logoPath()"
          [alt]="'Primo Network'"
          class="header-logo"
        />
      </button>

      @if (fullName()) {
        <div class="user-name-group">
          <div class="user-name small fw-semibold">
            {{ fullName() }}
          </div>

          @if (showProfileWarning()) {
            <button
              type="button"
              class="profile-warning-icon"
              ngbTooltip="Vai in impostazioni per completare la compilazione dei tuoi dati"
              container="body"
              aria-label="Profilo incompleto. Vai in impostazioni per completare la compilazione dei tuoi dati"
              (click)="goToSettings()"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                <path d="M7.938 2.016a.13.13 0 0 1 .125 0l6.857 11.856c.05.087.05.193 0 .28a.25.25 0 0 1-.22.128H1.3a.25.25 0 0 1-.22-.128.28.28 0 0 1 0-.28L7.938 2.016zM8 5c-.535 0-.954.462-.9.995l.35 3.507a.55.55 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 5zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
              </svg>
            </button>
          }
        </div>
      }
      <div class="header-right-spacer" aria-hidden="true"></div>
    </div>
  </div>
</div>
